import {
  REPORT_LOAN_LIST_REQUEST,
  REPORT_LOAN_LIST_REQUEST_ERROR,
  REPORT_LOAN_LIST_REQUEST_SUCCESS,
  REPORT_LOAN_LIST_EXPORT,
  REPORT_LOAN_LIST_EXPORT_SUCCESS,
  REPORT_LOAN_LIST_EXPORT_ERROR,
  REPORT_END_DAY_REQUEST,
  REPORT_END_DAY_EXPORT,
  DASHBOARD_REQUEST,
  DASHBOARD_REQUEST_ERROR,
  DASHBOARD_REQUEST_SUCCESS,
  END_DAY_CHANGE_STATUS,
  END_DAY_CHANGE_STATUS_ERROR,
  END_DAY_CHANGE_STATUS_SUCCESS,
  END_DAY_RE_CHANGE_STATUS,
  END_DAY_RE_CHANGE_STATUS_ERROR,
  END_DAY_RE_CHANGE_STATUS_SUCCESS,
} from '@/store/actions/report';
import { handleRequestError } from '@/utils/error';

import Repository, { REPORTS } from '@/repositories/RepositoryFactory';

const ReportsRepository = Repository.get(REPORTS);

const state = {
  reportLoanList: [],
  reportLoanListMeta: '',
  reportLoanListStatus: '',
  reportLoanExportStatus: '',
  reportLoanExportLink: '',
  dashboard: {},
  dashboardStatus: '',
  endDayChangeId: null,
  endDayChangeStatus: '',
  endDayReChangeStatus: '',
};

const getters = {
  reportLoanList: state => state.reportLoanList,
  reportLoanListMeta: state => state.reportLoanListMeta,
  reportLoanListStatus: state => state.reportLoanListStatus,
  reportLoanExportStatus: state => state.reportLoanExportStatus,
  reportLoanExportLink: state => state.reportLoanExportLink,
  dashboard: state => state.dashboard,
  dashboardStatus: state => state.dashboardStatus,
  endDayChangeId: state => state.endDayChangeId,
  endDayChangeStatus: state => state.endDayChangeStatus,
  endDayReChangeStatus: state => state.endDayReChangeStatus,
};

const actions = {
  [REPORT_LOAN_LIST_REQUEST]: async ({ commit }, payload) => {
    commit(REPORT_LOAN_LIST_REQUEST);
    try {
      const response = await ReportsRepository.getOverdueLoans(payload.data);
      commit(REPORT_LOAN_LIST_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(REPORT_LOAN_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },

  [REPORT_LOAN_LIST_EXPORT]: async ({ commit }, payload) => {
    commit(REPORT_LOAN_LIST_EXPORT);
    try {
      const response = await ReportsRepository.export(payload.data);
      commit(REPORT_LOAN_LIST_EXPORT_SUCCESS, response.data.data);
    } catch (error) {
      commit(REPORT_LOAN_LIST_EXPORT_ERROR);
      handleRequestError(error);
    }
  },

  [REPORT_END_DAY_REQUEST]: async ({ commit }, payload) => {
    commit(REPORT_LOAN_LIST_REQUEST);
    try {
      const response = await ReportsRepository.getEndDay(payload);
      commit(REPORT_LOAN_LIST_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(REPORT_LOAN_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },

  [REPORT_END_DAY_EXPORT]: async ({ commit }, payload) => {
    commit(REPORT_LOAN_LIST_EXPORT);
    try {
      const response = await ReportsRepository.exportEndDay(payload);
      commit(REPORT_LOAN_LIST_EXPORT_SUCCESS, response.data.data);
    } catch (error) {
      commit(REPORT_LOAN_LIST_EXPORT_ERROR);
      handleRequestError(error);
    }
  },

  [DASHBOARD_REQUEST]: async ({ commit }) => {
    commit(DASHBOARD_REQUEST);
    try {
      const response = await ReportsRepository.dashboard();
      commit(DASHBOARD_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(DASHBOARD_REQUEST_ERROR);
      handleRequestError(error);
    }
  },

  [END_DAY_CHANGE_STATUS]: async ({ commit }, id) => {
    commit(END_DAY_CHANGE_STATUS, id);
    try {
      await ReportsRepository.endDayChangeStatus(id);
      commit(END_DAY_CHANGE_STATUS_SUCCESS, id);
    } catch (error) {
      commit(END_DAY_CHANGE_STATUS_ERROR);
      handleRequestError(error);
    }
  },

  [END_DAY_RE_CHANGE_STATUS]: async ({ commit }, id) => {
    commit(END_DAY_RE_CHANGE_STATUS, id);
    try {
      await ReportsRepository.endDayReChangeStatus(id);
      commit(END_DAY_RE_CHANGE_STATUS_SUCCESS);
    } catch (error) {
      commit(END_DAY_RE_CHANGE_STATUS_ERROR);
      handleRequestError(error);
    }
  },
};

const mutations = {
  [REPORT_LOAN_LIST_REQUEST]: state => {
    state.reportLoanListStatus = 'loading';
  },
  [REPORT_LOAN_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.reportLoanListStatus = 'success';
    state.reportLoanList = payload.data;
    state.reportLoanListMeta = payload.meta;
  },
  [REPORT_LOAN_LIST_REQUEST_ERROR]: state => {
    state.reportLoanListStatus = 'error';
  },

  [REPORT_LOAN_LIST_EXPORT]: state => {
    state.reportLoanExportStatus = 'loading';
    state.reportLoanExportLink = '';
  },
  [REPORT_LOAN_LIST_EXPORT_SUCCESS]: (state, payload) => {
    state.reportLoanExportStatus = 'success';
    state.reportLoanExportLink = payload;
  },
  [REPORT_LOAN_LIST_EXPORT_ERROR]: state => {
    state.reportLoanExportStatus = 'error';
  },
  [DASHBOARD_REQUEST]: state => {
    state.dashboardStatus = 'loading';
  },
  [DASHBOARD_REQUEST_SUCCESS]: (state, payload) => {
    state.dashboardStatus = 'success';
    state.dashboard = payload.data;
  },
  [DASHBOARD_REQUEST_ERROR]: state => {
    state.dashboardStatus = 'error';
  },
  [END_DAY_CHANGE_STATUS]: (state, id) => {
    state.endDayChangeStatus = 'loading';
    state.endDayChangeId = id;
  },
  [END_DAY_CHANGE_STATUS_SUCCESS]: state => {
    state.endDayChangeStatus = 'success';
    state.endDayChangeId = null;
  },
  [END_DAY_CHANGE_STATUS_ERROR]: state => {
    state.endDayChangeStatus = 'error';
    state.endDayChangeId = null;
  },
  [END_DAY_RE_CHANGE_STATUS]: (state, id) => {
    state.endDayReChangeStatus = 'loading';
    state.endDayChangeId = id;
  },
  [END_DAY_RE_CHANGE_STATUS_SUCCESS]: state => {
    state.endDayReChangeStatus = 'success';
    state.endDayChangeId = null;
  },
  [END_DAY_RE_CHANGE_STATUS_ERROR]: state => {
    state.endDayReChangeStatus = 'error';
    state.endDayChangeId = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
